import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  item: {
    padding: theme.spacing(1),
  },
}))
